var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10956 2.58227C5.84156 2.31027 5.84156 1.87327 6.10956 1.60327C6.37756 1.33327 6.81056 1.33227 7.07856 1.60327L14.9086 9.51127C15.0372 9.6417 15.1094 9.81755 15.1094 10.0008C15.1094 10.184 15.0372 10.3598 14.9086 10.4903L7.07856 18.3983C7.01529 18.4625 6.93987 18.5135 6.85669 18.5484C6.77351 18.5832 6.68423 18.6011 6.59406 18.6011C6.50388 18.6011 6.41461 18.5832 6.33143 18.5484C6.24825 18.5135 6.17283 18.4625 6.10956 18.3983C5.98071 18.2681 5.90843 18.0924 5.90843 17.9093C5.90843 17.7261 5.98071 17.5504 6.10956 17.4203L13.2506 10.0003L6.10956 2.58227Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronArrowRight);
export default __webpack_public_path__ + "static/media/chevron-arrow-right.7d63e9ca496cbc6ccfc316a8d3bd8184.svg";
export { ForwardRef as ReactComponent };